export class Blockade {
  id: number = 0;
  name: string;
  description: string;
  startAt: string;
  startByUserId: number;
  endAt: string;
  endByUserId: number;
  userId: number;
  userAccessAuthorizationId: number;

  constructor(blockade?: Blockade) {
    if (blockade != null) {
      this.id = blockade.id;
      this.name = blockade.name;
      this.description = blockade.description;
      this.startAt = blockade.startAt;
      this.startByUserId = blockade.startByUserId;
      this.endAt = blockade.endAt;
      this.endByUserId = blockade.endByUserId;
      this.userId = blockade.userId;
      this.userAccessAuthorizationId = blockade.userAccessAuthorizationId;
    }
  }

  static isActive = (blockade: Blockade) => {
    let startAtDate = new Date(blockade.startAt);
    let endAtDate = blockade.endAt != null ? new Date(blockade.endAt) : null;
    let nowDate = new Date(Date.now());
    return startAtDate <= nowDate && (endAtDate == null || endAtDate > nowDate);
  }
}
